import React, { useEffect, useRef, useMemo } from 'react';
import { Marker, } from 'react-leaflet';
import { flagIcon } from './marker-icon';
import { WaypointPopUp } from './WaypointPopUp';
import sphereKnn from 'sphere-knn';
import { moveWaypoint, getAllWaypoints, } from '../../../services';
import { useDetailsContext } from '../details';

export const WaypointMarker = ({wpt, activityId, timeFormatError, handleDeleteWaypoint}) => {
    // console.log('WaypointMarker', wpt);
    const [state, dispatch] = useDetailsContext();
    const { route } = state.selectedRoute;
    const { userPrefUnits } = state;
    const { waypoints } = state;
    const markerRef = useRef(wpt.id);
    const routeLookupRef = useRef();

    const dragEnabled = wpt.index > 0 && waypoints[waypoints.length -1].index ? true : false;

    useEffect(() => {
        // Update the reference to the route when it changes
        routeLookupRef.current = sphereKnn(route);
      }, [route]);

    function position(wpt, route) {
        try {
            if (wpt.index >= 0 && route[wpt.index])
                return [route[wpt.index].lat ? route[wpt.index].lat : 0, route[wpt.index].lon ? route[wpt.index].lon : 0];
            else
                return [0, 0];
        } catch (error) {
            console.log('position error', error);
        }
    }

    const eventHandlers = useMemo(() => ({
        moveend(e) {
            // console.log('eventHandlers - moveend - WaypointMarker', wpt);
                const { lat, lng } = e.target._latlng;
                const foundPoint = routeLookupRef.current(lat, lng, 1, 1250);
                if (foundPoint.length) {
                    const p = foundPoint[0];
                    dispatch({ type: 'SET_INDICATOR', payload: p });
                    const newWptIndex = route.findIndex((point) => point.lat === p.lat && point.lon === p.lon);
                    try {
                        moveWaypoint(wpt.id, newWptIndex, wpt.title)
                        .then(() => getAllWaypoints(activityId))
                        .then((res) => dispatch({ type: 'FETCH_WAYPOINTS', payload: res }));
                    }
                    catch (error) {
                        console.log('moveWaypoint error', error);
                    }
                }
            },
        }),
      [activityId, dispatch, route, routeLookupRef, wpt],
    )

    return (
        <Marker
            key={wpt.id}
            position={position(wpt, route)}
            icon={flagIcon}
            title={wpt.title}
            alt={`wpt${wpt.id}`}
            draggable={dragEnabled}
            zIndexOffset={1}
            interactive={true}
            ref={markerRef}
            eventHandlers={eventHandlers}
        >
            <WaypointPopUp wpt={wpt} 
                userPrefUnits={userPrefUnits}
                activityId={activityId}
                timeFormatError={timeFormatError}
                handleDeleteWaypoint={handleDeleteWaypoint}
            />
        </Marker>
    );
}